module.exports = __webpack_public_path__ + "img/logo_color.e2570d60.png";